import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
type FAQItem = {
  question: string;
  answer: string;
};
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const toggleFAQ = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  const faqs: FAQItem[] = [{
    question: 'No tengo tiempo ni me gusta cocinar, ¿me va a servir?',
    answer: 'Sí. Todo está pensado para 10–15 min reales y 4–5 pasos. Si puedes armar un sándwich, puedes hacer estas recetas.'
  }, {
    question: 'Mi airfryer es pequeña/antigua, ¿funciona igual?',
    answer: 'Funciona. Indicamos cantidades por ración y cómo ajustar tiempos/temperatura. También sugerimos "cocción en tandas", sin perder textura crujiente.'
  }, {
    question: '¿Necesito balanza o ingredientes difíciles de encontrar?',
    answer: 'No. Usamos tazas/cucharas y alimentos que consigues en cualquier supermercado. Hay equivalencias simples y alternativas por si te falta algo.'
  }, {
    question: 'Estoy cuidando macros/definición, ¿cómo sé qué comer?',
    answer: 'Cada receta incluye:• Calorías totales\n• Proteínas (g)\n• Carbohidratos (g)\n• Grasas (g)\nY opciones para aumentar proteína o reducir carbohidratos/grasas sin perder sabor.'
  }, {
    question: '¿Y si soy vegetariano o necesito evitar gluten?',
    answer: 'Muchas recetas tienen alternativa vegetariana y marcamos sin gluten cuando aplica. De todas formas, revisa las etiquetas de cada ingrediente.'
  }, {
    question: '¿Me voy a quedar con hambre?',
    answer: 'No. Hay guías de porción y combinaciones (plato principal + guarnición) para saciedad. Además, snacks altos en proteína que son perfectos entre comidas.'
  }, {
    question: '¿Qué pasa si no me convence?',
    answer: 'Tienes 7 días de garantía. Si no te sirve, te devolvemos tu dinero sin preguntas.'
  }, {
    question: '¿Cómo pago? ¿Es seguro?',
    answer: 'Aceptamos tarjetas de crédito/débito y PayPal. Todas las transacciones están protegidas y recibirás un recibo por email.'
  }];
  // Only show first 3 FAQs initially
  const visibleFaqs = showAllFaqs ? faqs : faqs.slice(0, 3);
  return <section className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <div className="text-center mb-10" data-id="element-154">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-155">
            Preguntas frecuentes
          </h2>
          <p className="text-gray-700" data-id="element-156">
            Todo lo que necesitas saber antes de comprar
          </p>
        </div>
        <div className="space-y-4" data-id="element-157">
          {visibleFaqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-158">
              <button className="flex justify-between items-center w-full px-6 py-4 text-left" onClick={() => toggleFAQ(index)} data-id="element-159">
                <span className="font-medium text-gray-900" data-id="element-160">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-teal-600 flex-shrink-0" data-id="element-161" /> : <ChevronDownIcon className="h-5 w-5 text-teal-600 flex-shrink-0" data-id="element-162" />}
              </button>
              {openIndex === index && <div className="px-6 pb-4 text-gray-700 whitespace-pre-line" data-id="element-163">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
        {!showAllFaqs && <div className="mt-6 text-center" data-id="element-164">
            <button onClick={() => setShowAllFaqs(true)} className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-6 rounded-lg transition duration-300" data-id="element-165">
              Ver más preguntas
            </button>
          </div>}
        <div className="mt-10 text-center" data-id="element-166">
          <p className="text-gray-700 mb-4" data-id="element-167">
            Compras una vez, recibes actualizaciones gratis para siempre.
          </p>
          <a href="https://organicecomm.com/cart/51818275930293:1" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300" onClick={trackPurchaseClick} data-id="element-168">
            Quiero mi recetario por $17 USD
          </a>
        </div>
      </div>
    </section>;
};